import { render, staticRenderFns } from "./PasswordRecovery.vue?vue&type=template&id=0840fc5a&scoped=true&"
import script from "./PasswordRecovery.vue?vue&type=script&lang=js&"
export * from "./PasswordRecovery.vue?vue&type=script&lang=js&"
import style0 from "./PasswordRecovery.vue?vue&type=style&index=0&id=0840fc5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0840fc5a",
  null
  
)

/* custom blocks */
import block0 from "./PasswordRecovery.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0840fc5a')) {
      api.createRecord('0840fc5a', component.options)
    } else {
      api.reload('0840fc5a', component.options)
    }
    module.hot.accept("./PasswordRecovery.vue?vue&type=template&id=0840fc5a&scoped=true&", function () {
      api.rerender('0840fc5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/authentication/PasswordRecovery.vue"
export default component.exports